<template><Members initial-tab="cancellations" /></template>
<script>
import Members from '@/views/dkmall/member'
export default { name:'DkCancellation', components:{ Members } }
</script>
